import { convertToObjById } from "helpers/convertToObject"

const initialState = {
  loading: false,
  tags: {},
  tagsList: [],
  error: ''
}

export const LOAD_TAGS_V2 = "LOAD_TAGS_V2"
export const SET_TAGS_V2 = "SET_TAGS_V2"
export const ADD_NEW_TAG_V2 = "ADD_NEW_TAG_V2"
export const EDIT_TAG_V2 = "EDIT_TAG_V2"



export const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TAGS_V2:
      return {
        ...state,
        loading: true
      }

    case SET_TAGS_V2:
      const addLabel = action.payload.map(tag => {
        return {
          ...tag,
          label: `${tag.number} - ${tag.access} - ${tag.employeeNumber}`,
          value: tag.id,
          select: false
        }
      })
      const tagsConvert = convertToObjById(addLabel)
      const tags = addLabel
      return {
        ...state,
        loading: false,
        tags: tagsConvert,
        tagsList: tags
      }

    case ADD_NEW_TAG_V2:
      const { payload: payloadA } = action
      const tagsS = {...state.tags}
      const tagsArr = [...state.tagsList]
      const pl = {
        ...payloadA,
        label: `${payloadA.number} - ${payloadA.access} - ${payloadA.employeeNumber}`,
        value: payloadA.id
      }
      tagsS[payloadA.id] = pl
      tagsArr.push(pl)
      return {
        ...state,
        tags: tagsS,
        tagsList: tagsArr
      }

      case EDIT_TAG_V2:
        const { payload } = action
        const tagsS2 = {...state.tags}
        const tagsArr2 = [...state.tagsList]
        const pl2 = {
          ...payload,
          label: `${payload.number} - ${payload.access} - ${payload.employeeNumber}`,
          value: payload.id
        }
        tagsS2[payload.id] = pl2
        const idx = tagsArr2.findIndex(tag => tag.id === payload.id)
        if(idx !== -1) {
          tagsArr2[idx] = pl2
        }
        return {
          ...state,
          tags: tagsS2,
          tagsList: tagsArr2 
        }

    default:
      return state
  }
}